export default __webpack_public_path__ + "static/media/feature_3.60eba22e.png";